import { createReducer } from '@reduxjs/toolkit';
import type { Profile } from '@vgtv/api-client/lib/cnp_tag';

import { getPageComponentsPresetProfiles } from '../helpers';
import {
  fetchPageByCategoryId,
  fetchPageBySlug,
  fetchPageByStoryId,
  fetchPageByTagId,
} from '../pages';

import { fetchProfiles } from './actions';

export * from './selectors';

export type ProfilesState = Record<Profile['id'], Profile>;

const initialState: ProfilesState = {};

function storeProfilesFromPageComponentsPreset(
  state: ProfilesState,
  action: Pick<
    ReturnType<
      | typeof fetchPageByCategoryId.fulfilled
      | typeof fetchPageByTagId.fulfilled
      | typeof fetchPageByStoryId.fulfilled
      | typeof fetchPageBySlug.fulfilled
    >,
    'type' | 'payload'
  >
) {
  if (action.payload) {
    const pageConfig = action.payload;

    const profiles = getPageComponentsPresetProfiles(pageConfig);

    profiles.forEach((profile) => {
      state[profile.id] = profile;
    });
  }
}

const profilesReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(fetchProfiles.fulfilled, (state, action) => {
      const profiles = action.payload;

      profiles.forEach((profile) => {
        state[profile.id] = profile;
      });
    })
    .addCase(
      fetchPageByCategoryId.fulfilled,
      storeProfilesFromPageComponentsPreset
    )
    .addCase(fetchPageByTagId.fulfilled, storeProfilesFromPageComponentsPreset)
    .addCase(
      fetchPageByStoryId.fulfilled,
      storeProfilesFromPageComponentsPreset
    )
    .addCase(fetchPageBySlug.fulfilled, storeProfilesFromPageComponentsPreset)
);

export {
  profilesReducer,
  fetchProfiles,
  storeProfilesFromPageComponentsPreset,
};
